import Typography from '@mui/material/Typography';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';
import PropTypes from 'prop-types';
import React from 'react';

const AggActionIntro = ({ aggAction, fiBrandingIndent, onSubmit }) => (
  <>
    <StdDialogContent sx={{ pl: `${fiBrandingIndent}px` }} id='agg_action_intro_dialog'>
      <Typography variant='titleMedium' sx={{ fontWeight: '500', lineHeight: '1.25' }}>
        {aggAction.text}
      </Typography>
      {aggAction.additionalInfo && (
        <Typography variant='bodyRegular' sx={{ mt: 2, lineHeight: '1.25', whiteSpace: 'pre-line' }}>
          {aggAction.additionalInfo}
        </Typography>
      )}
      {(aggAction.statusCode || aggAction.code) && (
        <Typography variant='captionRegular' sx={{ mt: 2 }}>
          Care code: {aggAction.statusCode || aggAction.code}
        </Typography>
      )}
    </StdDialogContent>
    <StdDialogActions
      primary={{
        children: aggAction.actionLabel,
        onClick: onSubmit,
      }}
    />
  </>
);

AggActionIntro.propTypes = {
  aggAction: PropTypes.object.isRequired,
  fiBrandingIndent: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AggActionIntro;
